import React from 'react'
import ContactLayout from './contactlayout';
import BecomeRider from './becomerider';

const BecomeRiderPage = () => {
    return (
        <ContactLayout>
            <BecomeRider />
        </ContactLayout>
    )
}

export default BecomeRiderPage
